(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AlmaTunnusAuthHosted", [], factory);
	else if(typeof exports === 'object')
		exports["AlmaTunnusAuthHosted"] = factory();
	else
		root["AlmaTunnusAuthHosted"] = factory();
})(window, function() {
return 